import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/instrumentos/encuesta_preguntas_grupo_interes'

const getEncuestaPreguntas = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const getEncuestaPreguntaPorField = async (field, value) => {
  if(field && value) {
    const response = await axios.get(`${BASE_URL_ENDPOINT}/?${field}=${value}`)
    return response.data
  } else {
    return { results: [] }
  }
}

const crearEncuestaPregunta = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarEncuestaPregunta = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre, onSuccessMessage }
}

const actualizarEncuestaPregunta = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getEncuestaPreguntas,
  getEncuestaPreguntaPorField,
  crearEncuestaPregunta,
  eliminarEncuestaPregunta,
  actualizarEncuestaPregunta,
}